import type { VoidFunctionComponent } from 'react';

import { titleCase } from '../../../../shared/utils';
import Loader from '../../../components/generic/Loader';
import Tabs from '../../../components/generic/Tabs';
import NotFound from '../../NotFound';
import { useIsPrivatePortalEnabled, useVisibility } from '../hooks';
import type { Visibility } from '../hooks/useVisibility';

import PrivateReleaseGroupList from './PrivateReleaseGroupList';
import List from './ReleaseGroupList';

import styles from './ReleaseGroupList.module.less';

const tabIds: Visibility[] = ['public', 'private'];

/**
 * Renders the list of release groups that have published reports allowing the user to view or download the SBOM.
 */
const ReleaseGroupList: VoidFunctionComponent = () => {
  const { isPrivatePortalEnabled, isLoading } = useIsPrivatePortalEnabled();
  const { visibility, navigateToTab } = useVisibility();

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <div className={styles.main}>
        {isPrivatePortalEnabled && (
          <Tabs>
            {tabIds.map((tab) => (
              <Tabs.Tab
                key={tab}
                label={titleCase(tab)}
                isActive={visibility === tab}
                onSelect={() => {
                  navigateToTab(tab);
                }}
              />
            ))}
          </Tabs>
        )}
        {visibility === 'public' && <List visibility="public" />}
        {visibility === 'private' && isPrivatePortalEnabled && <PrivateReleaseGroupList />}
      </div>
      {/* Don't show NotFound component if private portal is disabled */}
      {visibility === 'private' && !isPrivatePortalEnabled && <NotFound />}
    </>
  );
};

export default ReleaseGroupList;
